/**
 * Offene Posten (/order-open-balances/new/overview): document create patch + dunning redirect.
 * Impower creates documents in one POST (with pdfData); template PUT is kept as a fallback.
 */
;(function registerLuxFetchHandlerOpenBalances() {
  const OPEN_BALANCES_OVERVIEW_RE = /^\/order-open-balances\/new\/overview$/
  const DOCUMENTS_API_PATH = '/services/pmp-document/api/v1/documents'
  const dunningApiUrl = '/services/pmp-accounting/api/v1/dunning'
  let savedRedirectUrl = ''

  function isDocumentsCreatePost(url, method) {
    if (method !== 'POST') return false
    try {
      const pathname = new URL(url, window.location.origin).pathname.replace(/\/$/, '')
      return pathname === DOCUMENTS_API_PATH
    } catch {
      return false
    }
  }

  function isDunningCreateEntry(entry) {
    return (
      !!entry &&
      typeof entry === 'object' &&
      entry.sourceType === 'DUNNING' &&
      Number(entry.sourceId) > 0
    )
  }

  function applyPropertyManagerPatch(dataObj) {
    if (!dataObj?.data?.propertyManagementCompanyName) return false
    const newManager = 'Team Buchhaltung der ' + dataObj.data.propertyManagementCompanyName
    dataObj.data.propertyManager = newManager
    if (Object.prototype.hasOwnProperty.call(dataObj.data, 'propertyManger')) {
      dataObj.data.propertyManger = newManager
    }
    return true
  }

  /** Patch propertyManager on create POST (pdfData) or legacy template PUT (pdfDataJsonString). */
  function patchPropertyManagerOnEntry(item) {
    if (!item || typeof item !== 'object') return

    if (item.pdfDataJsonString && typeof item.pdfDataJsonString === 'string') {
      try {
        const parsed = JSON.parse(item.pdfDataJsonString)
        if (applyPropertyManagerPatch(parsed)) {
          item.pdfDataJsonString = JSON.stringify(parsed)
        }
      } catch (error) {
        console.warn('Error setting property manager in pdfDataJsonString:', error)
      }
    }

    if (item.pdfData && typeof item.pdfData === 'string') {
      try {
        const parsed = JSON.parse(item.pdfData)
        if (applyPropertyManagerPatch(parsed)) {
          item.pdfData = JSON.stringify(parsed)
        }
      } catch {
        // pdfData may be HTML (ops-cost style); leave unchanged
      }
    }
  }

  function parseRequestBody(body) {
    if (typeof body === 'string') {
      try {
        return JSON.parse(body)
      } catch {
        return null
      }
    }
    if (body != null && typeof body === 'object' && !(body instanceof FormData) && !(body instanceof Blob)) {
      return body
    }
    return null
  }

  function firstDunningSourceId(payload) {
    if (!Array.isArray(payload)) return null
    for (const entry of payload) {
      if (!isDunningCreateEntry(entry)) continue
      return Number(entry.sourceId)
    }
    return null
  }

  function setRedirectFromSourceId(sourceId) {
    if (!Number.isFinite(sourceId) || sourceId <= 0) return
    savedRedirectUrl = `/nachrichtenversand?type=dunning&sourceIds=${sourceId}`
  }

  luxRegisterFetchHandler({
    id: 'open-balances',
    priority: 20,
    match(ctx) {
      if (!OPEN_BALANCES_OVERVIEW_RE.test(ctx.pathname)) return false
      const u = ctx.url
      return u.includes(DOCUMENTS_API_PATH) || u.includes(dunningApiUrl)
    },
    handle(ctx, nativeFetch) {
      const u = ctx.url
      const options = ctx.args[1] || {}

      // Legacy: PUT /documents/template still patches propertyManager if Impower sends it.
      if (u.includes(DOCUMENTS_API_PATH) && u.includes('/template')) {
        try {
          const bodyStr = typeof options.body === 'string' ? options.body : null
          if (bodyStr) {
            const payload = JSON.parse(bodyStr)
            if (Array.isArray(payload)) {
              payload.forEach(patchPropertyManagerOnEntry)
              ctx.args[1] = { ...options, body: JSON.stringify(payload) }
            }
          }
        } catch (error) {
          console.warn('Error parsing PDF data:', error)
        }
      }

      // New flow: POST /documents with pdfData — patch propertyManager and capture sourceId.
      if (isDocumentsCreatePost(u, ctx.method)) {
        const run = async () => {
          let body = ctx.isStringUrl ? ctx.args[1]?.body : undefined
          if (body === undefined && !ctx.isStringUrl && ctx.args[0]?.body) {
            body = await ctx.args[0].clone().text()
          }

          const parsed = parseRequestBody(body)
          if (!Array.isArray(parsed) || parsed.length === 0) {
            return nativeFetch.apply(this, ctx.args)
          }

          parsed.forEach(patchPropertyManagerOnEntry)
          const newBody = JSON.stringify(parsed)
          const response = ctx.isStringUrl
            ? await nativeFetch.apply(this, [ctx.args[0], { ...(ctx.args[1] || {}), body: newBody }])
            : await nativeFetch.apply(this, [
                ctx.args[0].url,
                {
                  method: ctx.args[0].method,
                  headers: ctx.args[0].headers,
                  body: newBody,
                  credentials: ctx.args[0].credentials,
                },
              ])

          // Only arm redirect after a successful create. Setting it from the request body
          // before POST would leave a stale URL if create fails, and /update-state would
          // still navigate to Nachrichtenversand for a dunning with no letters.
          if (response.ok) {
            let sourceId = null
            try {
              const created = await response.clone().json()
              sourceId = firstDunningSourceId(
                Array.isArray(created) ? created : created?.content,
              )
            } catch {
              // ignore parse errors
            }
            if (sourceId == null) {
              sourceId = firstDunningSourceId(parsed)
            }
            if (sourceId != null) {
              setRedirectFromSourceId(sourceId)
            }
          } else {
            savedRedirectUrl = ''
          }

          return response
        }
        return run()
      }

      let p = nativeFetch.apply(this, ctx.args)

      // Do not read GETs / polling for redirect — they overwrite sourceId with undefined.
      if (u.includes(dunningApiUrl) && u.includes('/update-state') && savedRedirectUrl) {
        window.location.replace(savedRedirectUrl)
        savedRedirectUrl = ''
      }

      return p
    },
  })
})()
